import { DragDropLayoutTabDefinition } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { APP_RECORD_TYPES, ITEM_NAMES } from "vmd-types";

import { dropStaleLayoutComponents } from "../../utils/drop-stale-layout-components";
import { isRecordTypeVisible } from "../../utils/filter-reporting-items-by-record-type";

// Cards no longer registered while IT Service is hidden. A saved layout that
// still places one of these leaves an empty tile unless dropped at render time.
const STALE_REPORT_COMPONENT_IDS = new Set<string>(
  isRecordTypeVisible(APP_RECORD_TYPES.IT_SERVICE)
    ? []
    : ["numberOfITServicesComponent", "criticalityITServicesComponent"]
);

/**
 * Resolves the display title for the Reports page's id-1 ("Items") tab from
 * the tenant's configured item name (#2718).
 */
export function getItemsTabTitle(itemName: string | undefined): string {
  const dynamicItemNamePlural =
    ITEM_NAMES.find((item) => item.single === itemName)?.plural ??
    "Tracking Items";

  return itemName === "DC System" ? "DC Business Apps" : dynamicItemNamePlural;
}

/**
 * Builds the Reports page's display tabs from the saved layout (or a single
 * default tab when nothing has been saved yet), dropping stale components
 * and forcing the id-1 tab's title to the tenant's item name (#2413, #2718).
 */
export function getReportDisplayTabs(
  reportLayout: { tabs?: DragDropLayoutTabDefinition[] } | undefined,
  itemName: string | undefined,
  language: string
): DragDropLayoutTabDefinition[] {
  let tabs: DragDropLayoutTabDefinition[];
  if (reportLayout?.tabs && reportLayout.tabs.length > 0) {
    tabs = reportLayout.tabs;
  } else {
    tabs = [
      {
        id: 0,
        title: getLocalizedMessage(language, "tab1") || "Tab 1",
        rows: [{ id: 0, columnCount: 3, columns: [] }],
      },
    ];
  }

  tabs = dropStaleLayoutComponents(tabs, STALE_REPORT_COMPONENT_IDS);
  tabs = [...tabs].sort((firstTab, secondTab) => {
    if (firstTab.id === 1) return -1;
    if (secondTab.id === 1) return 1;
    return 0;
  });

  const itemsTabTitle = getItemsTabTitle(itemName);

  return tabs.map((tab) => ({
    ...tab,
    title: tab.id === 1 ? itemsTabTitle : tab.title,
  }));
}
